import AppConfig from '../configs/app.config.json';
import { url } from '../api/env';

export default async ({ app, router, store }) => {
  // Load app config
  const config =
    typeof AppConfig === 'string' ? JSON.parse(AppConfig) : AppConfig;
  store.commit('app/setAppConfig', config);

  // Fetch feature flags from backend
  try {
    const response = await fetch(`${url}/flags/`);
    if (response.ok) {
      const flags = await response.json();
      store.commit('app/setFeatureFlags', flags);
    }
  } catch (e) {
    console.warn('Failed to fetch feature flags, defaulting all to enabled');
  }
};
